// import React, { useState } from "react";
// import {
//   Bar,
//   BarChart,
//   Cell,
//   LabelList,
//   ResponsiveContainer,
//   Tooltip,
//   XAxis,
//   YAxis,
// } from "recharts";

// const data = [
//   { date: "2/4/2023", value: 500200 },
//   { date: "2/4/2021", value: 490000 },
//   { date: "2/4/2019", value: 470000 },
//   { date: "2/4/2017", value: 480000 },
// ];

// const renderCustomizedLabel = (props) => {
//   const { x, y, width, height, value, index, hoveredIndex } = props;

//   return (
//     <g>
//       <text
//         x={x + width + 5}
//         y={y + height / 2}
//         fill={index === hoveredIndex ? "#375DFB" : "#0A0D14"}
//         textAnchor="start"
//         dominantBaseline="middle"
//         fontSize={12}
//         fontWeight={500}
//         fillOpacity={index === hoveredIndex ? 1 : 0.4}
//         dx={4}
//       >
//         {`${value.toLocaleString()} €`}
//       </text>
//     </g>
//   );
// };

// const WatchlistPriceChangeChart = () => {
//   const [hoveredIndex, setHoveredIndex] = useState(null);

//   return (
//     <div className="flex-1 sm:h-full w-full h-[220px]">
//       <ResponsiveContainer width="100%" height="100%">
//         <BarChart layout="vertical" data={data} barSize={16}>
//           <XAxis hide type="number" />
//           <YAxis
//             type="category"
//             dataKey="date"
//             tickLine={false}
//             tickMargin={6}
//             axisLine={false}
//             tick={{ fontSize: 12, color: "#525866", fontWeight: 400 }}
//           />
//           <Tooltip cursor={{ fill: "transparent" }} />

//           <Bar dataKey="value" onMouseLeave={() => setHoveredIndex(null)}>
//             {data.map((entry, index) => (
//               <Cell
//                 key={`cell-${index}`}
//                 fill={index === hoveredIndex ? "#1DA1F2" : "#375DFB"}
//                 opacity={index === hoveredIndex ? "1" : "0.3"}
//                 onMouseEnter={() => setHoveredIndex(index)}
//               />
//             ))}
//             <LabelList
//               dataKey="value"
//               content={(props) =>
//                 renderCustomizedLabel({ ...props, hoveredIndex })
//               }
//             />
//           </Bar>
//         </BarChart>
//       </ResponsiveContainer>
//     </div>
//   );
// };

// export default WatchlistPriceChangeChart;

// Updated code

import CustomChartTooltip from "components/Tooltip/ChartTooltip";
import React, { useEffect, useState } from "react";
import {
  Bar,
  BarChart,
  Cell,
  LabelList,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";

const renderCustomizedLabel = (props) => {
  const { x, y, width, height, value, index, hoveredIndex } = props;

  return (
    <g>
      <text
        x={x + width + 5}
        y={y + height / 2}
        fill={index === hoveredIndex ? "#375DFB" : "#0A0D14"}
        textAnchor="start"
        dominantBaseline="middle"
        fontSize={12}
        fontWeight={500}
        fillOpacity={index === hoveredIndex ? 1 : 0.4}
        dx={4}
      >
        {`${value} €`}
      </text>
    </g>
  );
};

const WatchlistPriceChangeChart = ({ property }) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [data, setData] = useState([]);

  useEffect(() => {
    if (property && property?.history) {
      // Filter out items with a price 0
      const filteredHistory = property.history.filter(
        (item) => item.sale_price > 0
      );

      // Process the history data for chart
      const formattedData = filteredHistory.map((item) => ({
        date: new Date(item.changed_at).toLocaleDateString("en-US", {
          day: "numeric",
          month: "2-digit",
          year: "numeric",
        }),
        value: item.sale_price,
      }));
      setData(formattedData);
    }
  }, [property]);

  return (
    <div className="flex-1 sm:h-full w-full h-[220px]">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart layout="vertical" data={data} barSize={16}>
          <XAxis hide type="number" />
          <YAxis
            type="category"
            dataKey="date"
            tickLine={false}
            tickMargin={6}
            axisLine={false}
            tick={{ fontSize: 12, color: "#525866", fontWeight: 400 }}
          />

          <Tooltip
            cursor={{
              stroke: "#9291A5",
              strokeWidth: 0.5,
              strokeDasharray: "5 5",
            }}
            content={<CustomChartTooltip />}
          />

          <Bar dataKey="value" onMouseLeave={() => setHoveredIndex(null)}>
            {data.map((entry, index) => (
              <Cell
                key={`cell-${index}`}
                fill={index === hoveredIndex ? "#1DA1F2" : "#375DFB"}
                opacity={index === hoveredIndex ? "1" : "0.3"}
                onMouseEnter={() => setHoveredIndex(index)}
              />
            ))}
            <LabelList
              dataKey="value"
              content={(props) =>
                renderCustomizedLabel({ ...props, hoveredIndex })
              }
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default WatchlistPriceChangeChart;
